export default "__VITE_ASSET__DK_BCBvI__"